export interface UsageOverviewMinimizedPosition {
  x: number;
  y: number;
}

const MINIMIZED_WIDGET_MAX_WIDTH_PX = 288; // 18rem
const MINIMIZED_WIDGET_VIEWPORT_MARGIN_PX = 16; // 1rem
const DEFAULT_TOP_PX = 12; // 0.75rem

export function getMinimizedWidgetWidth(): number {
  return Math.min(
    MINIMIZED_WIDGET_MAX_WIDTH_PX,
    window.innerWidth - MINIMIZED_WIDGET_VIEWPORT_MARGIN_PX * 2,
  );
}

export function getDefaultMinimizedPosition(): UsageOverviewMinimizedPosition {
  const width = getMinimizedWidgetWidth();
  return {
    x: Math.max(
      MINIMIZED_WIDGET_VIEWPORT_MARGIN_PX,
      (window.innerWidth - width) / 2,
    ),
    y: DEFAULT_TOP_PX,
  };
}

export function clampMinimizedPosition(
  x: number,
  y: number,
  width: number,
  height: number,
): UsageOverviewMinimizedPosition {
  const margin = MINIMIZED_WIDGET_VIEWPORT_MARGIN_PX;
  return {
    x: Math.min(Math.max(margin, x), Math.max(margin, window.innerWidth - width - margin)),
    y: Math.min(Math.max(margin, y), Math.max(margin, window.innerHeight - height - margin)),
  };
}

export function parsePersistedMinimizedPosition(
  raw: string | null,
): UsageOverviewMinimizedPosition | null {
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as Partial<UsageOverviewMinimizedPosition>;
    if (
      typeof parsed.x !== "number" ||
      typeof parsed.y !== "number" ||
      !Number.isFinite(parsed.x) ||
      !Number.isFinite(parsed.y)
    ) {
      return null;
    }

    return { x: parsed.x, y: parsed.y };
  } catch {
    return null;
  }
}
